import {actionTypes} from '../types'
import products from '../product.json'

import Actions from "../constants/Actions";

const initialState = {
    cartItems: [],
    wishlists: [],
    products:[],

    nomeCompleto:[],
    sexo:[],
    cpf:[],
    dataNascimento:[],
    celular:[],
    email:[],
    loadingPage:false,
    cep:[],
    rua:[],
    numero:[],
    bairro:[],
    complemento:[],
    cidade:[],
    estado:[],

    comprimento:[],
    largura:[],
    altura:[],
    peso:[],

    cepOrigemProduto:[],
    drawerCarrinho:false,
    cepDestino:[],
    cepOrigem:[],
    formaEntrega:[],
    dataEntrega:[],
    valorFrete:0,
    isDescontoCrm:false,
    valorDesconto:0,
    descontoAutorizacao:null,
    shippingId:{},
    paymentId:{},
    tipoEntrega:"Retirada",
    produtos:[],
    subtotal:[],
    loading:false,
    orderNumber:{},
    tokenPatrus:{},
    search:[],
    filters:{
        griffe:[],
        grupo:[],
        subgrupo:[],
        grade:[],
        filial:[],
        precoMin:null,
        precoMax:null
    },
    filialOptions:[],
    productsPagination:{ page:1, pageSize:60, total:0, hasMore:false },
    loadingProducts:false

};

export const initialPagination = { page:1, pageSize:60, total:0, hasMore:false };

export const initialFilters = {
    griffe:[],
    grupo:[],
    subgrupo:[],
    grade:[],
    filial:[],
    precoMin:null,
    precoMax:null
};
  
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
   
          /////
          case Actions.DADOS_PESSOAIS:
            return {
                ...state,
                nomeCompleto:action.nomeCompleto,
                sexo:action.sexo,
                cpf:action.cpf,
                dataNascimento:action.dataNascimento,
                celular:action.celular,
                email:action.email
      
            };

            
            case Actions.SET_VALOR_CRM:
              return {
                  ...state,
                  isDescontoCrm:true,
                  valorDesconto:action.valorDesconto
              };

            case Actions.SET_VALOR_DESCONTO:
              return {
                  ...state,
                  isDescontoCrm: !!action.valorDesconto,
                  valorDesconto: action.valorDesconto || 0,
                  descontoAutorizacao: action.descontoAutorizacao || null,
              };

            case Actions.CLEAR_VALOR_DESCONTO:
              return {
                  ...state,
                  isDescontoCrm: false,
                  valorDesconto: 0,
                  descontoAutorizacao: null,
              };

            case Actions.SET_DESCONTO_AUTORIZACAO:
              return {
                  ...state,
                  descontoAutorizacao: action.descontoAutorizacao || null,
              };

            case Actions.UPDATE_CART_ITEM_DISCOUNT: {
              const { product_id, grade, filial, updates } = action.payload || {};
              return {
                ...state,
                cartItems: state.cartItems.map((item) => {
                  const sameProduct = String(item.product_id) === String(product_id);
                  const sameGrade = String(item.grade) === String(grade);
                  const sameFilial = String(item.filial || "") === String(filial || "");
                  if (sameProduct && sameGrade && sameFilial) {
                    return { ...item, ...updates };
                  }
                  return item;
                }),
              };
            }

            

           case Actions.DRAWER_CARRINHO:
            return {
                ...state,
                drawerCarrinho:action.drawerCarrinho
            };


            case Actions.LOADING_PAGE:
              return {
                  ...state,
                  loadingPage:action.loadingPage
              };



            case Actions.SEARCH:
              return {
                  ...state,
                  search:action.search
        
              };
  

            case Actions.TOKEN_PATRUS:
              return {
                  ...state,
                  tokenPatrus:action.tokenPatrus
        
              };

            case Actions.SHIPPING_ID:
              return {
                  ...state,
                  shippingId:action.shippingId
        
              };

              case Actions.ORDER_NUMBER:
                return {
                    ...state,
                    orderNumber:action.orderNumber
          
                };

              
            case Actions.PAYMENT_ID:
              return {
                  ...state,
                  paymentId:action.paymentId
        
              };

              case Actions.TIPO_ENTREGA:
                return {
                    ...state,
                    tipoEntrega:action.tipoEntrega
          
                };


            case Actions.LOADING:
              return {
                  ...state,
                  loading:action.loading
        
              };

            case Actions.CEP_ORIGEM_PRODUTO:
              return {
                  ...state,
                  cepOrigemProduto:action.cepOrigemProduto,
              };

              case Actions.SET_TODOS_PRODUTOS:
                return {
                    ...state,
                    products:action.products,
                };

              case Actions.APPEND_TODOS_PRODUTOS:
                return {
                    ...state,
                    products:[...state.products, ...action.products],
                };

              case Actions.SET_PRODUCTS_PAGINATION:
                return {
                    ...state,
                    productsPagination:action.productsPagination
                };

              case Actions.LOADING_PRODUCTS:
                return {
                    ...state,
                    loadingProducts:action.loadingProducts
                };

              case Actions.SET_FILTER:
                return {
                    ...state,
                    filters:{
                        ...state.filters,
                        [action.key]:action.value
                    }
                };

              case Actions.RESET_FILTERS:
                return {
                    ...state,
                    filters:initialFilters
                };

              case Actions.SET_FILIAL_OPTIONS:
                return {
                    ...state,
                    filialOptions:action.filialOptions
                };

                case Actions.MEU_CARRINHO:
                  return {
                      ...state,
                       cartItems:action.cartItems
            
                }; 
    
    
  

          case Actions.DADOS_ENTREGA:
              return {
                  ...state,
                  cep:action.cep,
                  rua:action.rua,
                  numero:action.numero,
                  bairro:action.bairro,
                  complemento:action.complemento,
                  cidade:action.cidade,
                  estado:action.estado
        
            }; 

            case Actions.valorFrete:
              return {
                  ...state,
                  valorFrete:action.valorFrete,       
            }; 
            
          case Actions.valorFrete:
              return {
                  ...state,
                  comprimento:action.comprimento,
                  largura:action.largura,
                  altura:action.altura,
                  peso:action.peso,
                  formaEntrega:action.formaEntrega
          };  

          case Actions.CARRINHO:
            return {
                ...state,
                carrinho: action.carrinho,
                subtotal:action.subtotal
         };
          /////

    case actionTypes.addToCart:

      return {
        ...state, 
        cartItems: [...state.cartItems, action.payload],
      };

    case actionTypes.removeFromCart:
      let filData = state.cartItems.filter(item => item.product_id !== action.payload.product_id)
      console.log('fildata', filData)
      action.payload.quantity_inc = 1
      return {
          ...state, 
          cartItems: filData, 
         // products: [...state.products, action.payload]
      }

    case actionTypes.addItemQty:
      let addItem = []
      state.cartItems.map(item => {
          if(item.id === action.payload.id){
              item.quantity_inc += 1
          }
          return addItem.push(item)
      })
      return {
          ...state, 
          cartItems: addItem, 
      }

    case actionTypes.removeItemQty:
      let removeItem = []
      state.cartItems.map(item => {
          if(item.id === action.payload.id){
              item.quantity_inc -= 1
          }
          return removeItem.push(item)
      })
      return {
          ...state, 
          cartItems: removeItem, 
      }

    case actionTypes.addWishlist:
      let filWishlist = state.cartItems.filter(item => item.id !== action.payload.id)
      action.payload.quantity_inc = 1
      return {
          ...state, 
          cartItems: filWishlist, 
          wishlists: [...state.wishlists, action.payload]
      }



    default:
      return state;
  }
}

export default cartReducer;
  